// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__20YM8","header":"ClearentDisclaimer_header__1fb85","inner":"ClearentDisclaimer_inner__EqO0-"};